export default {
  konstruktion: "17564D9EB96",
  werker: "1756A2907EE"
}
